import React from 'react';

function MetadataConfig({ data, onChange }) {
  const handleChange = (section, field, value) => {
    const newData = { ...data };
    if (!newData[section]) newData[section] = {};
    newData[section][field] = value;
    onChange(newData);
  };

  const handleKeywordsChange = (value) => {
    const keywords = value.split(',').map(k => k.trim()).filter(k => k);
    handleChange('identification', 'keywords', keywords);
  };

  return (
    <div className="row g-4">
      <div className="col-lg-6">
        <div className="card h-100 border-0 shadow-sm">
          <div className="card-header bg-info bg-opacity-10 border-0">
            <h5 className="card-title mb-0 text-info">
              <i className="bi bi-info-circle me-2"></i>
              Service Identification
            </h5>
          </div>
          <div className="card-body">
            <div className="mb-3">
              <label className="form-label fw-semibold">
                <i className="bi bi-card-heading me-1"></i>
                Title
              </label>
              <input 
                type="text" 
                className="form-control form-control-lg" 
                placeholder="My pygeoapi Service"
                value={data.identification?.title || ''} 
                onChange={(e) => handleChange('identification', 'title', e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">
                <i className="bi bi-card-text me-1"></i>
                Description
              </label>
              <textarea 
                className="form-control" 
                rows="4"
                placeholder="Describe your service and its capabilities..."
                value={data.identification?.description || ''} 
                onChange={(e) => handleChange('identification', 'description', e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">
                <i className="bi bi-tags me-1"></i>
                Keywords
              </label>
              <input 
                type="text" 
                className="form-control form-control-lg" 
                placeholder="geospatial, api, ogc, features"
                value={data.identification?.keywords?.join(', ') || ''} 
                onChange={(e) => handleKeywordsChange(e.target.value)}
              />
              <div className="form-text">
                <i className="bi bi-lightbulb me-1"></i>
                Separate keywords with commas
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">
                <i className="bi bi-link-45deg me-1"></i>
                Service URL
              </label>
              <input 
                type="url" 
                className="form-control form-control-lg" 
                placeholder="https://example.com/service"
                value={data.identification?.url || ''} 
                onChange={(e) => handleChange('identification', 'url', e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
      
      <div className="col-lg-6">
        <div className="card h-100 border-0 shadow-sm">
          <div className="card-header bg-secondary bg-opacity-10 border-0">
            <h5 className="card-title mb-0 text-secondary">
              <i className="bi bi-person-lines-fill me-2"></i>
              Contact & Provider Information
            </h5>
          </div>
          <div className="card-body">
            <div className="mb-4">
              <h6 className="text-muted mb-3">
                <i className="bi bi-person me-1"></i>
                Contact Person
              </h6>
              <div className="mb-3">
                <label className="form-label fw-semibold">Name</label>
                <input 
                  type="text" 
                  className="form-control form-control-lg" 
                  placeholder="John Doe"
                  value={data.contact?.name || ''} 
                  onChange={(e) => handleChange('contact', 'name', e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="form-label fw-semibold">Email</label>
                <div className="input-group input-group-lg">
                  <span className="input-group-text">
                    <i className="bi bi-envelope"></i>
                  </span>
                  <input 
                    type="email" 
                    className="form-control" 
                    placeholder="contact@example.com"
                    value={data.contact?.email || ''} 
                    onChange={(e) => handleChange('contact', 'email', e.target.value)}
                  />
                </div>
              </div>
            </div>
            
            <div>
              <h6 className="text-muted mb-3">
                <i className="bi bi-building me-1"></i>
                Organization
              </h6>
              <div className="mb-3">
                <label className="form-label fw-semibold">Organization Name</label>
                <input 
                  type="text" 
                  className="form-control form-control-lg" 
                  placeholder="My Organization"
                  value={data.provider?.name || ''} 
                  onChange={(e) => handleChange('provider', 'name', e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="form-label fw-semibold">Organization URL</label>
                <div className="input-group input-group-lg">
                  <span className="input-group-text">
                    <i className="bi bi-globe"></i>
                  </span>
                  <input 
                    type="url" 
                    className="form-control" 
                    placeholder="https://organization.com"
                    value={data.provider?.url || ''} 
                    onChange={(e) => handleChange('provider', 'url', e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MetadataConfig;